<template>
  <v-form ref="jobEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'job-index'})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col cols="12">
        <h1>{{this.id ? 'Редактирование вакансии' : 'Создание вакансии'}}</h1>
      </v-col>
      <v-col cols="12">
      <div class="">
        <v-img :src="previewImage(true, image)" width="246" height="195">
          <template v-slot:placeholder>
            <div class="image-placeholder"></div>
          </template>
        </v-img>
      </div>
      </v-col>
      <v-col  cols="12" sm="5" md="4" xl="3">
        <v-file-input label="Картинка"
                      prepend-icon=""
                      class="cursor-pointer"
                      outlined
                      placeholder="1902х1508.jpg"
                      append-icon="mdi-attachment"
                      v-model="image">
        </v-file-input>
        <v-tabs v-model="tabLang">
          <v-tab>RU</v-tab>
          <v-tab>UA</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabLang">
          <v-tab-item :eager="true">
            <v-row>
              <v-col>
                <v-text-field
                        v-model="job.name"
                        label="Заголовок"
                        :rules="[rules.required]"
                        required
                        outlined
                ></v-text-field>
                <v-textarea
                        v-model="job.description"
                        label="Описание"
                        :rules="[rules.required]"
                        required
                        outlined
                ></v-textarea>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-row>
              <v-col>
                <v-text-field
                    v-model="job.name_ua"
                    label="Заголовок"
                    :rules="[rules.required]"
                    required
                    outlined
                ></v-text-field>
                <v-textarea
                    v-model="job.description_ua"
                    :rules="[rules.required]"
                    required
                    label="Описание"
                    outlined
                ></v-textarea>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
        <v-checkbox
            v-model="job.active"
            label="Активная"
        ></v-checkbox>
        <v-btn v-if="id" @click="update">Сохранить</v-btn>
        <v-btn v-else @click="create">Создать</v-btn>
      </v-col>
      <v-snackbar
              v-model="snackbar"
              :timeout="timeout"
              :color="snackbarColor"
              right
              top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import JobService from './../../api/JobService'

  export default {
    name: 'JobEdit',
    props: {
        id: {
            default: null,
        }
    },
    components: {},
    data: () => ({
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      snackbarColor: '',
      rules: {
        required: value => !!value || 'Нужно заполнить',
        requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
      },
      valid: true,
      tab: '',
      tabLang: '',
      job: {
        name: '',
        name_ua: '',
        description: '',
        description_ua: '',
        active: true
      },
      image: null,
      loading: true,
      loadingButton: false,
    }),
    mounted() {
        if(this.id) {
            JobService.get(this.id)
                .then(response => {
                    this.job = response.data;

                    if (this.job.image) {
                        this.image = this.job.image;
                        this.image.name = this.job.image.file
                    }
                    this.loading = false
                });
        }
    },
    methods: {
      validate() {
        this.$refs.jobEditForm.validate()
        if(this.job.name == '' && this.job.name_ua != ''){
          this.tabLang = 0;
        }
        if(this.job.name != '' && this.job.name_ua == ''){
          this.tabLang = 1;
        }

        if (this.job.description == '' && this.job.description_ua != '') {
          this.tabLang = 0;
        }
        if (this.job.description != '' && this.job.description_ua == '') {
          this.tabLang = 1;
        }

      },
      previewImage(isList, image) {
        if(this.image && this.image.url){
            return this.image.url
        }
        if(image){
          return URL.createObjectURL(image)
        }
      },
      update(){
        this.validate()
        if(!this.valid){
          return false
        }

        this.loadingButton = true;
        let formData = this.getData();

        JobService.update(formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Вакансия успешно обновлена';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении вакансии';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      create(){
        this.validate()
        if(!this.valid){
          return false
        }
        this.loadingButton = true;
        var formData = this.getData();

        JobService.create(formData).then(response => {
            this.$router.push({ name: 'job-edit', params: { id: response.data.id } })
          this.job.id = response.id
          this.snackbar = true;
          this.snackbarText = 'Вакансия создана';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при создании ваканси';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      getData() {
          let formData = new FormData();

          formData.append('id', this.id);
          formData.append('name', this.job.name);
          formData.append('name_ua', this.job.name_ua);
          formData.append('description', this.job.description);
          formData.append('description_ua', this.job.description_ua);
          formData.append('active', this.job.active ? 1 : 0);
          if(this.image && !this.image.url) {
              formData.append('image', this.image);
          }

          return formData;
      }
    },
  }
</script>

<style scoped lang="scss">
  .image-placeholder{
    width: 100%;
    height: 100%;
    background-color: #F3F7FC;
    border-radius: 4px;
  }
  .job-images .v-image{
    max-height: 374px;
  }
  .mobile{
    width: 300px;
    height: 300px;
    margin-bottom: 24px;
  }
  .job{
    position: relative;
    &:before{
      content: "";
      padding-top: 100%;
      display: block;
    }

    .content{
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #F8FBFF;
      border-right-style: 3px;
      .img{
        height: 3.541vw;
        margin-top: .83vw;
      }
      .name{
        margin-top: .72vw;
        text-align: center;
        color: #8C959D;
      }
    }
  }
</style>
